<template>
    <div
        ref="newBookkeepingAccountPopup"
        class="fixed w-screen h-screen top-0 left-0 bg-black/60 z-60 flex items-center justify-center cursor-pointer"
        @keydown.esc="hide"
        @click.self.exact="hide"
    >
        <div class="rounded bg-base-100 shadow-lg cursor-auto flex flex-col w-[50em] p-3">
            <div class="text-xl mb-6">Ny konto</div>
            <bookkeeping-account-editor
                class="flex flex-col"
                :bookkeeping-account="bookkeepingAccount"
                :disable-teleport="true"
                @save="save"
                @cancel="hide"
            />
        </div>
    </div>
</template>

<script setup lang="ts">

import BookkeepingAccountEditor from '@/bookkeeping-account/BookkeepingAccountEditor.vue'
import {defaultBookkeepingAccount} from '@/bookkeeping-account/bookkeepingAccount.service'
import hotkeys from 'hotkeys-js'
import {BookkeepingAccount} from '@/bookkeeping-account/BookkeepingAccount'
import {ref} from 'vue'
import {notifySuccess} from '@/services/infrastructure/notification.service'

const newBookkeepingAccountPopup = ref<HTMLElement | null>(null)
const emit = defineEmits(['created', 'close'])
const hide = () => {
    emit('close')
}

const props = defineProps({
    name: {type: String, default: ''},
})

const bookkeepingAccount = ref({
        ...defaultBookkeepingAccount(),
        name: props.name,
        description: props.name
})

hotkeys('esc', hide)
const save = (newAccount: BookkeepingAccount) => {
    emit('created', newAccount)
    hide()
    notifySuccess({ title: 'Opprettet', description: `Kontoen ${newAccount.accountNo}:${newAccount.name} ble opprettet.`})
}

</script>

<style scoped></style>